import { Component, Input, ViewChild, ElementRef } from '@angular/core';
import { InitDataService } from '../system-services/InitData/InitData.service';
import { BasicPageLayoutOptions } from './BasicPageLayoutOptions';

@Component({
    selector: 'gradient-page-layout',
    host: {
        class: 'pageWrapper greyBackground',
        '[class.pagelayout--loading]': 'options.loading'
    },
    template: `
        <gradient-page-header [options]="options">
            <ng-container page-header-gradient>
                <ng-content select="[page-header-gradient]"></ng-content>
            </ng-container>
            <ng-container page-header-white>
                <ng-content select="[page-header-white]"></ng-content>
            </ng-container>
        </gradient-page-header>
        <basic-page-body [options]="options">
            <ng-container page-side-nav>
                <ng-content select="[page-side-nav]"></ng-content>
            </ng-container>
            <ng-container page-main-title>
                <ng-content select="[page-main-title]"></ng-content>
            </ng-container>
            <ng-container page-main-body>
                <ng-content select="[page-main-body]"></ng-content>
            </ng-container>
            <ng-container page-dlip-body>
                <ng-content select="[page-dlip-body]"></ng-content>
            </ng-container>
            <ng-container page-aside1-title>
                <ng-content select="[page-aside1-title]"></ng-content>
            </ng-container>
            <ng-container page-aside1-body>
                <ng-content select="[page-aside1-body]"></ng-content>
            </ng-container>
            <ng-container page-aside2-title>
                <ng-content select="[page-aside2-title]"></ng-content>
            </ng-container>
            <ng-container page-aside2-body>
                <ng-content select="[page-aside2-body]"></ng-content>
            </ng-container>
            <ng-container customAside
                ><ng-content select="[customAside]"></ng-content
            ></ng-container>
        </basic-page-body>
    `,
    standalone: false
})
export class GradientPageLayoutComponent {
    @Input()
    options: BasicPageLayoutOptions = {};
    @ViewChild('titleRef', { static: false })
    titleRef: ElementRef;
    @ViewChild('subtitleRef', { static: false })
    subtitleRef: ElementRef;

    constructor(public initData: InitDataService) {}
}
